var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.getMessage)?_c('div',{class:_vm.classes},[_c('div',{staticClass:"Message__inner"},[_vm._v(" "+_vm._s(_vm.getMessage.text)+" ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }